<template lang="pug">
.benchmarks-job-roles
  h5.benchmarks-heading Past 7 day average for all Hubstaff users

  .job-roles-stats
    .job-roles-stats-item(
      v-for="role in benchmarksJobRoles"
      :key="role.label"
    )
      p {{ role.label }}
      .job-roles-pill.benchmarks-pill(:class="pillClass(role.average)")
        | {{ role.average }}%

  h6 More options
  ul.job-roles-more
    li.job-roles-extra.benchmarks-meta Add position for team members on the
      |
      |
      a(:href="membersUrl") Members page
    li.job-roles-extra.benchmarks-meta
      a(:href="insightsUrl") Check out Insights
      |
      | for more benchmarks and trends
</template>

<script>
import { mapState } from 'vuex';
import { getAverageRange } from '~/utils/benchmarks';

export default {
  name: 'ActivitiesBenchmarksDialogJobRoles',
  props: {
    // TODO: Add back in once the API is ready
    // benchmarksJobRoles: {
    //   type: Array,
    //   required: true,
    // },
  },
  data: () => ({
    // TODO: This will come from the API later on, and passed via props
    benchmarksJobRoles: Object.freeze([
      { label: 'Copywriter', average: 44 },
      { label: 'Customer Success', average: 37 },
      { label: 'Customer', average: 71 },
      { label: 'Developer', average: 56 },
      { label: 'Data Input', average: 84 },
      { label: 'Marketing Manager', average: 61 },
      { label: 'Project', average: 64 },
      { label: 'SEO Specialist', average: 54 },
      { label: 'Sales', average: 29 },
      { label: 'Designer', average: 39 },
    ]),
  }),
  computed: {
    ...mapState({
      membersUrl: 'members_url',
      insightsUrl: 'insights_url',
    }),
  },
  methods: {
    pillClass(average) {
      return getAverageRange(average);
    },
  },
};
</script>
